.editor {
  position: absolute;
  z-index: 100;
  top: -10000px;
  left: -10000px;
  margin-top: -6px;
  max-width: 300px;
  width: 100%;
  opacity: 0;
  background-color: white;
  box-shadow: 0 5px 10px var(--shadow);
  transition: opacity 0.5s;
}

.editor .input {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid var(--button-border);
  outline: 0;
  position: relative;
}

.editor div.input {
  background-color: var(--main-background);
  height: 37px;
}

.editor input.input {
  background-color: white;
}

.editor div.edit {
  background-image: url("../images/pencil-fill.svg");
  background-size: 16px;
  background-position: center;
  background-repeat: no-repeat;
  width: 35px;
  vertical-align: -0.25em;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  cursor: pointer;
}

.editor .input a {
  color: rgb(33 111 219);
  text-decoration: none;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  margin-right: 30px;
  text-overflow: ellipsis;
}

.editor .input a:hover {
  text-decoration: underline;
}
